import { LoadingWrapper, LoadingIcon } from "./styled";

export const Loading = () => {
  return (
    <LoadingWrapper>
      <LoadingIcon />
    </LoadingWrapper>
  );
};
